import { useLocation, useNavigate } from "react-router-dom";
import { PATH, GRAB_WEB_ORIGIN_URL } from "@configs";
import { useEffect, useState } from "react";
import * as Sentry from "@sentry/react";
import { useTranslation } from "react-i18next";
import loading from "@assets/gif/loading.gif";
import { DebugPage } from "utils";

export const TokenExchangePage: React.FC = () => {
  const { i18n } = useTranslation();
  const { state } = useLocation();
  const [isGrabReadyToExchange, setIsGrabReadyToExchange] = useState(false);
  const [isSendTokenToGrab, setIsSendTokenToGrab] = useState(false);
  const [isTokenReceived, setIsTokenReceived] = useState(false);
  const navigate = useNavigate();

  const destination = `${GRAB_WEB_ORIGIN_URL}/mex-auth/token-exchange`;

  window.addEventListener("message", function (event) {
    if (event.origin === GRAB_WEB_ORIGIN_URL) {
      const message = event.data;
      if (message === "READY_FOR_EXCHANGE") {
        setIsGrabReadyToExchange(true);
        if (event?.source) {
          setIsSendTokenToGrab(true);
          if (state?.token) {
            event.source.postMessage(
              `TOKEN:${state?.token}`,
              destination as any
            );
          } else {
            event.source.postMessage(
              `ERROR:${state?.error}`,
              destination as any
            );
          }
        }
      }

      if (message === "TOKEN_RECEIVED") {
        setIsTokenReceived(true);
        navigate(PATH.GRAB_MAPPING);
      }
    }
  });

  useEffect(() => {
    if (state?.entry === "grab") {
      const userAgent = navigator.userAgent;

      if (/android/i.test(userAgent)) {
        try {
          if (state?.token) {
            (window as any).Grab.postMessage(`TOKEN:${state?.token}`);
          } else if (state?.error) {
            (window as any).Grab.postMessage(`ERROR:${state?.error}`);
          }
        } catch (e) {
          Sentry.captureException(e);
        }
      }

      if (/iPad|iPhone|iPod/.test(userAgent)) {
        try {
          if (state?.token) {
            (window as any).webkit.messageHandlers.Grab.postMessage(
              `TOKEN:${state?.token}`
            );
          } else if (state?.error) {
            (window as any).webkit.messageHandlers.Grab.postMessage(
              `ERROR:${state?.error}`
            );
          }
        } catch (e) {
          Sentry.captureException(e);
        }
      }
    }
  }, [state]);

  return (
    <>
      <DebugPage>
        <div className="text-black" id="test">
          Token Exchange
        </div>
        <div className="text-black">{`TOKEN : ${state?.token}`}</div>
        <div className="text-black">{`ERROR : ${state?.error}`}</div>
        <div className="text-black">{`Entry : ${state?.entry}`}</div>
        <div className="text-black">{`Is Grab Ready To Exchange Token : ${isGrabReadyToExchange}`}</div>
        <div className="text-black">{`Is Send Token To Grab : ${isSendTokenToGrab}`}</div>
        <div className="text-black">{`Is Token Received : ${isTokenReceived}`}</div>

        {state?.entry === "grab" ? (
          <>
            <div className="text-black">{`(window as any).webkit.messageHandlers.Grab : ${
              (window as any)?.webkit?.messageHandlers?.Grab
            }`}</div>
            <div className="text-black">{`(window as any).Grab : ${
              (window as any)?.Grab
            }`}</div>
          </>
        ) : null}
      </DebugPage>

      <div className="min-h-screen flex content-center items-center justify-center">
        <img src={loading} alt="loading" />
      </div>

      {destination && state?.entry === "line" ? (
        <iframe
          title="iframe_grab_web"
          id="grab_web"
          sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin"
          hidden
          src={`${destination}?lang=${i18n.language}`}></iframe>
      ) : null}
    </>
  );
};
